import STATUS_CODES from 'constants/statusCodes';
import SignUpServices from 'services/sign_up';
import { normalizeDealership } from './helpers';
import { AUCTION_ACCESS_LOOKUP_STATE } from './lookupState';
import { useState } from 'react';

const getName = (person) => [person?.first_name, person?.last_name].filter(Boolean).join(' ');

const getLookupAccount = ({ dealerships, person } = {}, auctionAccessId) => {
	const normalizedDealerships = Array.isArray(dealerships) ? dealerships.map(normalizeDealership) : [];
	return {
		firstName: person?.first_name,
		lastName: person?.last_name,
		name: getName(person),
		email: person?.email,
		mobilePhone: person?.cell_phone,
		auctionAccessId,
		dealerships: normalizedDealerships,
	};
};

const getLookupState = ({ decision, reason } = {}) => {
	if (decision === 'happy_path' || decision === 'company_selection_required') {
		return AUCTION_ACCESS_LOOKUP_STATE.SUCCESS;
	}
	if (reason === 'person_not_found') return AUCTION_ACCESS_LOOKUP_STATE.NOT_FOUND;
	if (reason === 'existing_user' || reason === 'existing_dealership') {
		return AUCTION_ACCESS_LOOKUP_STATE.ACCOUNT_EXISTS;
	}

	return AUCTION_ACCESS_LOOKUP_STATE.ERROR;
};

const useAuctionAccessLookup = (anonymousId) => {
	const [lookupState, setLookupState] = useState(AUCTION_ACCESS_LOOKUP_STATE.ENTRY);
	const [submittedAuctionAccessId, setSubmittedAuctionAccessId] = useState('');
	const [submittedPhotoIdLastFour, setSubmittedPhotoIdLastFour] = useState('');
	const [account, setAccount] = useState();

	const submitLookup = async ({ auctionAccessId, photoIdLastFour }) => {
		setSubmittedAuctionAccessId(auctionAccessId);
		setSubmittedPhotoIdLastFour(photoIdLastFour);
		setAccount();
		setLookupState(AUCTION_ACCESS_LOOKUP_STATE.LOADING);

		try {
			const { data } = await SignUpServices.instance.lookupAuctionAccess({
				auctionAccessId,
				anonymousId,
				photoIdLastFour,
			});
			setAccount(getLookupAccount(data || {}, auctionAccessId));
			setLookupState(getLookupState(data));
		} catch (response) {
			setLookupState(
				response?.status === STATUS_CODES.NOT_FOUND ?
					AUCTION_ACCESS_LOOKUP_STATE.UNAVAILABLE
				:	AUCTION_ACCESS_LOOKUP_STATE.ERROR,
			);
		}
	};

	const tryAgain = () => {
		setAccount();
		setLookupState(AUCTION_ACCESS_LOOKUP_STATE.ENTRY);
	};

	return {
		lookupState,
		submittedAuctionAccessId,
		submittedPhotoIdLastFour,
		account,
		submitLookup,
		tryAgain,
	};
};

export default useAuctionAccessLookup;
